import React from "react";

export default function PrivacyPolicy() {
  return (
    <div className="bg-white text-gray-800 font-sans">
      <div className="max-w-6xl mx-auto px-6 py-12">
        {/* Logo + Phone */}
        {/* <div className="flex md:flex-row flex-col gap-4 items-center justify-between mb-8">
          <img
            src="../Assets/logo_.webp"
            alt="Logo"
            className="w-44 h-auto"
          />
          <a
            href="tel:+971527195327"
            className="flex items-center space-x-2 text-white bg-[#997736] hover:bg-[#997736]/70 px-4 py-2 rounded-md shadow"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="currentColor"
              viewBox="0 0 512 512"
            >
              <path d="M497.39 361.8l-112-48a24 24 0 0 0-28 6.9l-49.6 60.6A370.66 370.66 0 0 1 130.6 204.11l60.6-49.6a23.94 23.94 0 0 0 6.9-28l-48-112A24.16 24.16 0 0 0 122.6.61l-104 24A24 24 0 0 0 0 48c0 256.5 207.9 464 464 464a24 24 0 0 0 23.4-18.6l24-104a24.29 24.29 0 0 0-14.01-27.6z" />
            </svg>
            <span>+971 52 719 5327</span>
          </a>
        </div> */}

        {/* Title */}
        <h2 className="md:text-5xl text-3xl text-center font-bold mb-10">
          Privacy Policy | Terms and Conditions
        </h2>

        {/* Content */}
        <div className="space-y-6 text-justify leading-relaxed">
          <p className="text-lg"> 
            <strong className="text-2xl">PRIVACY POLICY &amp; TERM OF USES</strong>
            <br />
            Nova Capital Real Estate LLC, (“Nova Capital Real Estate” or “We”) . We prioritize your privacy. Our concise Privacy Policy outlines the personal information we collect through our website, including sub-domains and microsites, the purposes of collection we may share it with, and security measures in place. It also informs you about your rights, choices, and how to contact us regarding privacy concerns. We highly recommend reading this Privacy Policy before using services and/or providing personal information. </p>
          <p className="text-lg">
            <strong className="text-2xl">INTERPRETATIONS AND DEFINITIONS</strong>
          </p>
          <p className="text-lg">“Data” shall mean personal information, including sensitive personal information and special category personal data (as defined under Data Protection Laws) about you, which we collect, receive, or otherwise process in connection with your use of our website and/or the Platform.

“Data Protection Laws” shall mean any applicable law for the time being in force relating to the processing of Data.

 “User or You” shall mean the natural person who accesses our website/pages or Platform.

</p>
          <p className="text-lg">
            <strong className="text-2xl">WEBSITE CONTENT OVERVIEW:</strong>
            <br />
            The contents of this landing page, containing details of properties, property photos, costs, and availability, are provided for informational and illustrative purposes only. This information is subject to change at any time. Users are hereby advised that the actual properties may differ from what is shown in photos and cost on the website and pages, and as such, no claims shall be entertained based on such representations.
Uses of Developer Information:
All images, cost descriptions, logos, and other project materials featured on this landing page are presented in accordance with the respective project developer or its licensors. We are in legal agreements and established legal relationships with the said respective developer, thereby possessing the authority to advertise, market for sale, and generate leads for the respective project.


          </p>
          <p className="text-lg">
            <strong className="text-2xl">TYPES OF DATA COLLECTED</strong>
          </p>
          <p className="text-lg">
            <strong className="text-2xl">PERSONAL DATA</strong>
          </p>
          <p className="text-lg">
            While visiting to this website, we may ask You to provide Us with certain personally identifiable information that can be used to contact or identify You. Personally identifiable information may include, but is not limited to:

Email address:info@novaproperty.ae
Address: Icon Tower, Barsha Heights, Dubai-UAE
We may use Personal Data for the following purposes:

To provide and maintain our Service, including to monitor the usage of our Service.
To contact You: To contact You by email, telephone calls, SMS, or other equivalent forms of electronic communication.
To provide Information related to the property’s sale, purchase etc. with, special offers and general information about properties, real estate services which we offer that are similar to those that you have already purchased or enquired about.
To manage Your requests: To attend and manage Your requests to Us.
We may share Your personal information in the following situations:

With Affiliates: We may share Your information with Our affiliates, in which case we will require those affiliates to honor this Privacy Policy. Affiliates include Our associates and any other subsidiaries, that We control or that are under common control with Us.
With Authorized Developers: We may disclose Your personal information with RERA registered Developers for further processing as necessary.
With Your consent: We may disclose Your personal information for any other purpose with Your consent.
          </p>
          <p className="text-lg">
            <strong className="text-2xl">RETENTION OF YOUR PERSONAL DATA</strong>
            <br />
            We shall retain Your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use Your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws).
          </p>
          <p className="text-lg">
            <strong className="text-2xl">DISCLOSURE OF YOUR PERSONAL DATA</strong>
          </p>
          <p className="text-lg">
            <strong className="text-2xl">USER'S CONSENT</strong>
          </p>
          <p className="text-lg">By using the Website/Landing Page and/or by providing information to Us through this Website/Landing Page, the User consents to the collection and use of the information disclosed by the User on the Website in accordance with this Privacy Policy.</p>
          <p className="text-lg">
            <strong className="text-2xl">LAW ENFORCEMENT</strong>
            <br />
            Under certain circumstances, the We may be required to disclose Your Personal Data if required to do so by law or in response to valid requests by public authorities (e.g. a court or a government agency).
          </p>
          <p className="text-lg">
            <strong className="text-2xl">OTHER LEGAL REQUIREMENTS</strong>
            <br />
            The Company may disclose Your Personal Data in the good faith belief that such action is necessary to:

Comply with a legal obligation.
Prevent or investigate possible wrongdoing in connection with the Service.
Protect the personal safety of Users of the Service or the public.
Protect against legal liability.
          </p>
          <p className="text-lg">
            <strong className="text-2xl">SECURITY OF YOUR PERSONAL DATA</strong>
          </p>
          <p className="text-lg">
            The security of Your Personal Data is important to Us but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While We strive to use commercially acceptable means to protect Your Personal Data, we cannot guarantee its absolute security.
          </p>
          <p className="text-lg">
            <strong className="text-2xl">CHILDREN'S PRIVACY</strong>
            <br />
            Our Service does not address anyone under the age of 18. We do not knowingly collect personally identifiable information from anyone under the age of 18. If You are a parent or guardian and You are aware that Your child has provided Us with Personal Data, please contact Us. If We become aware that We have collected Personal Data from anyone under the age of 18 without verification of parental consent, we take steps to remove that information from Our servers.


          </p>
          <p className="text-lg">
            <strong className="text-2xl">CHANGES TO THIS PRIVACY POLICY</strong>
            <br />
            We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the new Privacy Policy on this page. You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.


          </p>
          <p className="text-lg">
            <strong className="text-2xl">CONTACT US</strong>
            <br />
            To request to review, update, or delete your personal information or to otherwise reach us, please submit a request by e-mailing us  
            at <strong className="text-2xl">info@novaproperty.ae</strong>
          </p>
        </div>
      </div>
    </div>
  );
}
